import { apiGet, apiPut, apiPost, throwApiError } from "../utils";

export const DailyPollType = Object.freeze({
  Binary: "binary",
  Multiple: "multipleChoice",
});

export const getDailyPolls = async (page, perPage, search = "") => {
  const response = await apiGet("/admin/daily-poll", { page, perPage, search });
  const { items, totalCount, message } = await response.json();

  throwApiError(message);

  return { items, totalCount };
};

export const getDailyPollById = async (pollId) => {
  const response = await apiGet(`/admin/daily-poll/${pollId}`);
  const { message, ...poll } = await response.json();

  throwApiError(message);

  return poll;
};

export const createDailyPoll = async (payload) => {
  const response = await apiPost("/admin/daily-poll", payload);
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throwApiError(data);
    throw data?.error || data?.message || "Failed to create daily poll";
  }

  const { message, ...result } = data;

  throwApiError(message);

  return result;
};

export const updateDailyPoll = async (pollId, payload) => {
  const response = await apiPut(`/admin/daily-poll/${pollId}`, payload);
  const { message, ...result } = await response.json();

  throwApiError(message);

  return result;
};

export const activateDailyPoll = async (pollId) => {
  const response = await apiPut(`/admin/daily-poll/${pollId}/activate`);
  const { message, ...result } = await response.json();

  throwApiError(message);

  return result;
};

export const deactivateDailyPoll = async (pollId) => {
  const response = await apiPut(`/admin/daily-poll/${pollId}/deactivate`);
  const { message, ...result } = await response.json();

  throwApiError(message);

  return result;
};
